const urljoin = require('url-join');
const hostname = window.location.host;

let base = "https://www.mrlc.gov/eva_services_v2/services/LandCoverAtlas";
let mapServiceBase = "https://dmsdata.cr.usgs.gov/geoserver/wms";
//let mapServiceBase = "https://igskmn011sl0231.cr.usgs.gov:8443/geoserver/wms";
let boundaries= "https://www.mrlc.gov/geoserver/mrlc_display/ows?service=wfs&version=1.1.0&request=GetFeature&outputFormat=application/json&typeNames=mrlc_display:lcmap_uscounties_CONUS&srsName=EPSG:5070&CQL_FILTER=STCO_FIPSC=";


if (hostname.match('localhost') || hostname.match('dev')) {
base = 'https://devmrlc.cr.usgs.gov/eva_services_v2/services/LandCoverAtlas';
//base = 'https://developermrlc.cr.usgs.gov:57107/eva_services_v2/services/LandCoverAtlas';
mapServiceBase = 'https://dmsdata.cr.usgs.gov/geoserver/wms';
//mapServiceBase = "https://igskmn011sl0231.cr.usgs.gov:8443/geoserver/wms";
boundaries = 'https://www.mrlc.gov/geoserver/mrlc_display/ows?service=wfs&version=1.1.0&request=GetFeature&outputFormat=application/json&typeNames=mrlc_display:lcmap_uscounties_CONUS&srsName=EPSG:5070&CQL_FILTER=STCO_FIPSC=';
}

module.exports = {
  lookups: {
    "regions": urljoin(base, "getDataCountyWatershedYearDataCoverage"),
  },
  charts: [
    //tab 1
    urljoin(base, "getCountyOverallChangePercent"),
    urljoin(base, "getCountyOverallDistributionOfLandCoverByType"),
    urljoin(base, "getCountyDistributionLossesGains"),
    urljoin(base, "getLandCoverChangeSummaryTableFor_Reporting"),
    //tab 2
    urljoin(base, "getCountyDevelopedAreaPercentage"),
    urljoin(base, "getCountyImperviousAreaPercentage"),
    urljoin(base, "getCountyDevelopedAreaPercentageChange"),
    urljoin(base, "getCountyImpervAreaPercentageChange"),
    urljoin(base, "getCountyDistributionNetDevelopedChange"),
    urljoin(base, "getCountyDistributionLossByClass"),
    //tab 3
    urljoin(base, "getCountyForestedPercentage"),
    urljoin(base, "getCountyForestedAreaChange"),
    urljoin(base, "getCountyCoreForestedAreaChange"),
    urljoin(base, "getCountyNonCoreForestedAreaChange"),
    urljoin(base, "getCountyForestDistribution"),
    urljoin(base, "getNetChangeGainedOrLostFromNonForested"),
    //tab 4
    urljoin(base, "getCountyWetlandsPercentage"),
    urljoin(base, "getCountyWetlandAreaChange"),
    urljoin(base, "getCountyWetlandFreshwaterAreaChange"),
    urljoin(base, "getCountyWetlandSaltwaterAreaChange"),
    urljoin(base, "getCountyWetlandsChange"),
    urljoin(base, "getCountyWetlandsDistributionLossesByClass"),
	//tab 5
    urljoin(base, "getCountyAgriculturePercentage"),
    urljoin(base, "getCountyAgricultureAreaChange"),
    urljoin(base, "getCountyAgricultureChange"),
    urljoin(base, "getCountyAgricultureDistributionLossesByClass"),
    //print report
    // urljoin(base, "getPercentageHiMedLowOpenVsNonDeveloped"),
    // urljoin(base, "getPercentageForestedVsNonForested"),
    // urljoin(base, "getNetChangeForestFragmentation"),
    // urljoin(base, "getPercentageWetlandsVsNonWetlands"),
    // urljoin(base, "getNetChangeAllWetlandsClasses"),
    // urljoin(base, "getNetChangeGainedOrLostFromNonWetland")
 
  ],
  mapServices: {
    startYear: 1985,
    endYear: 2025,
    boundaries: boundaries,
    base_url: mapServiceBase,
    landcover: //"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",

    {
      1985:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1986:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1987:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1988:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1989:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1990:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1991:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1992:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1994:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1995:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1996:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1993:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1997:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1998:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      1999:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2000:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2001:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2002:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2003:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2004:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2005:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2006:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2007:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2008:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2009:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2011:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2012:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2013:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2010:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2014:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2015:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2016:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2017:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2018:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2019:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2020:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2021:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2022:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2023:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2024:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
      2025:"mrlc_Land-Cover-Native_conus_year_data:Land-Cover-Native_conus_year_data",
    },

    satelliteBaseMapURL: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}',
    streetsBaseMapURL: 'https://osm-{1-4}.gs.mil/tiles/default/{z}/{x}/{y}.png'
  }
}